module.exports = __webpack_public_path__ + "media/images/home/sc1-0aa1004637b0ff5a9ae9b79bef8e446d.webp";